"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDropZoneDebugStyle = exports.DEBUG_SHOW_DROP_ZONES = void 0;
exports.DEBUG_SHOW_DROP_ZONES = false;
function getDropZoneDebugStyle(_a) {
    var _b = _a.isOver, isOver = _b === void 0 ? false : _b;
    if (!exports.DEBUG_SHOW_DROP_ZONES) {
        return {};
    }
    return isOver
        ? { backgroundColor: "rgba(0, 255, 0, 0.4)" }
        : { backgroundColor: "rgba(0, 255, 0, 0.08)" };
}
exports.getDropZoneDebugStyle = getDropZoneDebugStyle;
//# sourceMappingURL=debug.js.map